import { z } from 'zod';

/**
 * Schema de validación para Productos
 * Usa Zod para validación en runtime y TypeScript
 */

export const productSchema = z.object({
  name: z
    .string()
    .min(1, 'El nombre del producto es requerido')
    .max(100, 'El nombre no puede exceder 100 caracteres')
    .trim(),
  
  description: z
    .string()
    .max(50000, 'La descripción no puede exceder 50,000 caracteres')
    .optional()
    .default(''),
  
  price: z
    .number({
      required_error: 'El precio es requerido',
      invalid_type_error: 'El precio debe ser un número',
    })
    .positive('El precio debe ser mayor a 0')
    .max(99999.99, 'El precio no puede exceder S/ 99,999.99'),
  
  compare_at_price: z
    .number({
      invalid_type_error: 'El precio de comparación debe ser un número',
    })
    .min(0, 'El precio de comparación no puede ser negativo')
    .max(99999.99, 'El precio de comparación no puede exceder S/ 99,999.99')
    .optional()
    .nullable()
    .default(null),
  
  unit_price: z
    .string()
    .optional()
    .default(''),
  
  tax_included: z
    .boolean()
    .default(false),
  
  cost: z
    .number({
      invalid_type_error: 'El costo debe ser un número',
    })
    .min(0, 'El costo no puede ser negativo')
    .optional()
    .nullable()
    .default(null),
  
  category: z
    .string()
    .min(1, 'Debes seleccionar una categoría'),
  
  image_url: z
    .string()
    .max(500, 'La URL de la imagen no puede exceder 500 caracteres')
    .default('🍽️'),
  
  stock: z
    .number({
      required_error: 'El stock inicial es requerido',
      invalid_type_error: 'El stock debe ser un número',
    })
    .int('El stock debe ser un número entero')
    .min(0, 'El stock no puede ser negativo')
    .max(999999, 'El stock no puede exceder 999,999'),
  
  is_active: z
    .boolean()
    .default(true),
});

// Tipo TypeScript inferido del schema
export type ProductFormData = z.infer<typeof productSchema>;
